import { useState } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { FaWhatsapp } from "react-icons/fa";

export default function ProteinCalculator() {

    const [weight, setWeight] = useState("");
    const [goal, setGoal] = useState("maintenance");

    const [protein, setProtein] = useState(null);
    const [range, setRange] = useState("");
    const [tips, setTips] = useState([]);

    function calculateProtein() {

        if (!weight) {
            alert("Please enter your weight");
            return;
        }

        let proteinPerKg = 1.6;

        if (goal === "fatloss") {
            proteinPerKg = 2.2;
        }

        if (goal === "musclegain") {
            proteinPerKg = 2;
        }

        if (goal === "maintenance") {
            proteinPerKg = 1.6;
        }

        const totalProtein = Math.round(weight * proteinPerKg);

        setProtein(totalProtein);

        setRange(
            `${Math.round(weight * 1.6)}g - ${Math.round(weight * 2.2)}g`
        );

        setTips([
            "Include protein in every meal.",
            "Consume lean meats, eggs, fish, dairy and legumes.",
            "Spread protein intake throughout the day.",
            "Aim for 20-40g protein per meal.",
            "Combine protein intake with resistance training."
        ]);
    }

    return (
        <>
            <title>Protein Calculator | The Fitness Expert - Calculate Your Daily Protein Intake</title>
            <meta name="description" content="Use The Fitness Expert's free Protein Calculator to estimate your daily protein requirements based on your weight, fitness goal, and activity level. Find the ideal protein intake for muscle gain, fat loss, or maintaining a healthy lifestyle." />
            <meta name="keywords" content="protein calculator, daily protein calculator, protein intake calculator, protein requirement calculator, muscle gain protein calculator, fat loss protein calculator, bodybuilding protein calculator, nutrition calculator, fitness calculator, protein per day calculator, online protein calculator, free protein calculator, The Fitness Expert" />
            <meta property="og:title" content="Free Protein Calculator | The Fitness Expert" />
            <meta property="og:site_name" content="The Fitness Expert" />
            <meta property="og:url" content="https://thefitnessexpert.in/user/ProteinCalculator" />
            <meta property="og:description" content="Calculate your daily protein intake with The Fitness Expert's free Protein Calculator. Get personalized protein recommendations for muscle building, fat loss, and overall health." />

            <meta property="og:image" content="logo.png"></meta>
            <meta name="twitter:card" content="app" />
            <meta name="twitter:site" content="@thefitnessexpert" />
            <meta name="twitter:description" content="Calculate your daily protein intake with The Fitness Expert's free Protein Calculator. Get personalized protein recommendations for muscle building, fat loss, and overall health." />
            <meta name="twitter:app:country" content="India" />

            <Navbar />
            <section className="py-5 proteinn" >
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-7">
                            <div className="card border-0 shadow-lg rounded-4 bgg">
                                <div className="card-body p-5">
                                    <h2 className="text-center text-white fw-bold mb-2">Protein Calculator</h2>
                                    <p className="text-center text-secondary mb-4">Find your ideal daily protein intake</p>
                                    <div className="mb-3">
                                        <label className="form-label text-white">Weight (kg)</label>
                                        <input type="number" className="form-control" placeholder="Enter Weight" value={weight} onChange={(e) => setWeight(e.target.value)} />
                                    </div>
                                    <div className="mb-4">
                                        <label className="form-label text-white">Goal</label>
                                        <select className="form-select" value={goal} onChange={(e) => setGoal(e.target.value)}>
                                            <option value="maintenance">Maintenance</option>
                                            <option value="fatloss">Fat Loss</option>
                                            <option value="musclegain">Muscle Gain</option>
                                        </select>
                                    </div>
                                    <button className="btn btn-danger w-100" onClick={calculateProtein}>
                                        Calculate Protein
                                    </button>
                                    {protein && (
                                        <>
                                            <div className="text-center mt-4 p-4 rounded-4 bg2">
                                                <h5 className="text-white">Daily Protein Requirement</h5>
                                                <h1 className="text-danger fw-bold display-4">
                                                    {protein}g
                                                </h1>
                                            </div>
                                            <div className="row mt-4 g-3">
                                                <div className="col-md-6">
                                                    <div className="p-3 rounded-4 h-100 bg2">
                                                        <small className="text-secondary">
                                                            Recommended Range
                                                        </small>
                                                        <h4 className="text-success mt-2">
                                                            {range}
                                                        </h4>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="p-3 rounded-4 h-100 bg2">
                                                        <small className="text-secondary">Fitness Goal</small>
                                                        <h4 className="text-info mt-2 text-capitalize">
                                                            {goal}
                                                        </h4>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="mt-4 p-4 rounded-4 bg2">
                                                <h5 className="text-white mb-3">
                                                    Recommended Nutrition Tips
                                                </h5>
                                                <ul className="mb-0">
                                                    {tips.map((tip, index) => (
                                                        <li key={index} className="text-light mb-2">
                                                            💪 {tip}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>

                                            <div className="mt-4 p-4 rounded-4 bg3">
                                                <h5 className="text-danger mb-3">
                                                    High Protein Foods
                                                </h5>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <ul className="text-light">
                                                            <li>Chicken Breast</li>
                                                            <li>Eggs</li>
                                                            <li>Fish</li>
                                                            <li>Greek Yogurt</li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <ul className="text-light">
                                                            <li>Paneer</li>
                                                            <li>Milk</li>
                                                            <li>Soya Chunks</li>
                                                            <li>Lentils</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="position-fixed bottom-0 end-0 p-3 z-3">
                <button className="fixed-join-btn text-light fw-bold px-3 py-2 shadow rounded-pill bgcolor"
                    onClick={() =>
                        window.open("https://wa.me/919876857579?text=Hello%20Harman%20Sir%20👋%0A%0AI%20visited%20your%20website%20and%20I'm%20interested%20in%20your%20fitness%20coaching%20programs.", "_blank"
                        )}>
                    <FaWhatsapp size={24} />
                </button>
            </div>
            <Footer />
        </>
    );
}